<template>
  <a-config-provider>
    <!-- <Header /> -->
    <router-view v-if="isRouterAlive" :key="$route.fullPath" />
    <!-- <Footer /> -->
  </a-config-provider>
</template>

<script>
import { reactive, ref, nextTick, onMounted } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enGB from 'ant-design-vue/es/locale/en_GB'
import { useI18n } from 'vue-i18n'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { useStore } from 'vuex'

export default {
  provide() {
    return {
      adminReload: this.reload,
    }
  },

  components: { Header, Footer },

  setup() {
    const isRouterAlive = ref(true)
    const { locale } = useI18n()
    const store = useStore()
    store.dispatch('getCommonEnumList')
    store.dispatch('getMenuList')

    onMounted(() => {})

    const reload = () => {
      isRouterAlive.value = false
      nextTick(() => {
        isRouterAlive.value = true
      })
    }

    return {
      isRouterAlive,
      reload,
      zhCN,
      enGB,
      locale,
    }
  },
}
</script>

<style lang="scss" scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
<style lang="scss">
.ant-message {
  top: 70px;
}
</style>
